var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlag02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60.607,
    height: 40.196,
    viewBox: "0 0 60.607 40.196",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_22323",
    "data-name": "Caminho 22323",
    d: "M161.76,155.15v40.2h60.607v-40.2Zm20.652,23.814a3.14,3.14,0,0,1-3.033-3.231v-4.2h6.066v4.2A3.14,3.14,0,0,1,182.412,178.964Zm-5.737-10.135V173.9h-3.088a8.943,8.943,0,0,1,7.472-7.472v2.405Zm.067,7.772a5.869,5.869,0,0,0,4.317,4.894v2.578a8.943,8.943,0,0,1-7.472-7.472Zm7.022,4.894a5.869,5.869,0,0,0,4.316-4.894h3.156a8.941,8.941,0,0,1-7.472,7.472Zm4.385-7.6v-5.067h-4.385v-2.405a8.94,8.94,0,0,1,7.472,7.472Zm-23.686-16.042h16.6v5.837a11.635,11.635,0,0,0,0,23.114v5.837h-16.6Zm55.2,34.787h-35.9v-5.837a11.635,11.635,0,0,0,0-23.115v-5.836h35.9Z",
    transform: "translate(-161.76 -155.15)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag02);
export default __webpack_public_path__ + "static/media/flag-02.1525084feacea4cbbe62cd1e102c6063.svg";
export { ForwardRef as ReactComponent };